'use client'

/* eslint-disable no-undef */
import { useEffect, useState } from 'react'

const isClient = require('./isClient')

const MAPPER = {
  mobile: 'screen and (max-width: 767px)',
  tablet: 'screen and (min-width: 768px)',
  desktop: 'screen and (min-width: 1025px)'
}

const useMediaQuery = (device = 'mobile') => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    if (isClient()) {
      const onResize = () =>
        setMatches(window.matchMedia(MAPPER[device]).matches)
      onResize()
      window.addEventListener('resize', onResize)

      return () => {
        window.removeEventListener('resize', onResize)
      }
    }
  }, [])

  return matches
}

export default useMediaQuery
